import PropTypes from 'prop-types'
import { pipe, propOr } from 'ramda'
import { useEffect } from 'react'

import useAuth from './stores/use-auth'
import useProfile from './stores/use-profile'

const loggedInSelector = pipe(propOr(null, 'current'), Boolean)

const User = ({ children }) => {
  const isLoggedIn = useAuth(loggedInSelector)

  const initializeAuth = useAuth.use.initialize()
  const loadProfile = useProfile.use.loadProfile()

  useEffect(() => {
    initializeAuth()
  }, [initializeAuth])

  useEffect(() => {
    if (isLoggedIn) {
      loadProfile()
    }
  }, [isLoggedIn, loadProfile])

  return children
}

export default User

User.propTypes = {
  children: PropTypes.element.isRequired,
}
